<gc-icon-badge [iconSrc]="icon()"
               [alt]="label() | translate"
               [background]="background()"
               [size]="size()"
               [styleClass]="styleClass()"></gc-icon-badge>
